import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-match_order",
  "use": "icon-match_order-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-match_order\">\n<path d=\"M15.3002 15.3L3.3002 15.3C2.96882 15.3 2.7002 15.0314 2.7002 14.7L2.7002 2.70001\" stroke=\"white\" stroke-linecap=\"round\" />\n<path d=\"M4.5 11.1273H7.47931V4.50006H11.5759V7.07733H15.3V12.6001\" stroke=\"#FEFEFF\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol